import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Services from '@/views/Services'
import About from '@/views/About'
import Careers from '@/views/Careers'
import PageNotFound from '@/views/PageNotFound'
import Projects from '@/views/Projects'
import ContactUs from '@/views/ContactUs'
import ProjectInfo from '@/views/ProjectInfo'
import TermsAndConditions from '@/views/TermsAndConditions'
import privacyPolicy from '@/views/PrivacyPolicy'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta:{
      title: 'Digital Threads - Home',
      description: 'Software development company in Yerevan, Armenia. Web and mobile applications, custom software, QA and dedicated development teams.',
      background:'transparent'
    }
  },
  {
    path: '/services',
    name: 'Services',
    component: Services,
    meta:{
      title: 'Digital Threads - Services',
      description: 'Web and mobile application development, custom software, e-commerce, testing and QA, dedicated developers and outsourced product development.',
      background:'white'
    }
  },
  {
    path: '/About',
    name: 'About',
    component: About,
    meta:{
      title: 'Digital Threads - About',
      description: 'Who we are: a team of developers, designers and QA engineers in Yerevan building software for long-term partners.',
      background:'white'
    }
  },
  {
    path: '/Careers',
    name: 'Careers',
    component: Careers,
    meta:{
      title: 'Digital Threads - Careers',
      description: 'Open positions at Digital Threads. Join a team that works hard, grows fast and has a lot of fun along the way.',
      background:'white'
    }
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects,
    meta:{
      title: 'Digital Threads - Projects',
      description: 'Projects we delivered: web platforms, mobile apps and custom business software for clients across industries.',
      background:'white'
    }
  },
  {
    path: '/project-info/:id',
    name: 'ProjectInfo',
    component: ProjectInfo,
    meta:{
      title: 'Digital Threads - Project Info',
      description: 'Case study of a project delivered by the Digital Threads team.',
      background:'white'
    }
  },
  {
    path: '/contact-us',
    name: 'contactUs',
    component: ContactUs,
    meta:{
      title: 'Digital Threads - Contact Us',
      description: 'Get in touch with Digital Threads. Abelyan Street 6/4, Yerevan, Armenia. We answer every request.',
      background:'white'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'pageNotFound',
    component: PageNotFound,
    meta:{
      title: 'Digital Threads - Not Found',
      description: 'This page does not exist. Go back to the Digital Threads homepage.',
      background:'white',
      hideFooter: false
    }
  },
  {
    path: '/privacy_policy',
    name: 'privacy-policy',
    component: privacyPolicy,
    meta:{
      title: 'Digital Threads - Privacy Policy',
      description: 'How Digital Threads collects, uses and protects your personal data.',
      background:'white',
      hideFooter: false
    }
  },
  {
    path: '/terms_and_conditions',
    name: 'terms-and-conditions',
    component: TermsAndConditions,
    meta:{
      title: 'Digital Threads - Terms and Conditions',
      description: 'Terms and conditions of using the Digital Threads website.',
      background:'white',
      hideFooter: false
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if(to.hash === '#workflow') {
      document.getElementById(to.hash.slice(1)).scrollIntoView({ behavior: 'smooth' });
    } else if(to.hash === '#open-position') {
      document.getElementById(to.hash.slice(1)).scrollIntoView({ behavior: 'smooth' });
    } else if (to.hash) {
      document.getElementById(to.hash.slice(1)).scrollIntoView({ behavior: 'smooth' });
    } else {
      document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
    }
  }
})

function setMetaContent(attr, value, content) {
  const tag = document.querySelector(`meta[${attr}="${value}"]`)
  if (tag) tag.setAttribute('content', content)
}

router.beforeEach((to, from, next) => {
  const nearestWithTitle        = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  const nearestWithMeta         = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title
  }

  // Описание и og-теги заданы в index.html статически — здесь обновляем их
  // содержимое, а не добавляем вторую копию.
  const nearestWithDescription = to.matched.slice().reverse().find(r => r.meta && r.meta.description)

  if (nearestWithDescription) {
    const description = nearestWithDescription.meta.description
    const title = nearestWithTitle ? nearestWithTitle.meta.title : document.title

    setMetaContent('name', 'description', description)
    setMetaContent('property', 'og:description', description)
    setMetaContent('property', 'og:title', title)
    setMetaContent('property', 'og:url', window.location.origin + to.path)
    setMetaContent('name', 'twitter:description', description)
    setMetaContent('name', 'twitter:title', title)

    const canonical = document.querySelector('link[rel="canonical"]')
    if (canonical) canonical.setAttribute('href', window.location.origin + to.path)
  }

  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

  if (!nearestWithMeta) return next()

  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta')

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key])
    })

    tag.setAttribute('data-vue-router-controlled', '')

    return tag
  })
    .forEach(tag => document.head.appendChild(tag))

  next()
})

export default router
